import { webSvc } from ".";

export const refreshAccessToken = async (payload) => {
  let APIURL = process.env.REACT_APP_API_URL + "/api/v1";

  const response = await webSvc.post(APIURL+ "/auth/refresh", payload);
  return response.data;
};